// $(document).ready(function() {

//     var lineCountLimit = 3;
//     var lineLengthLimit = 16;

//     window.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
//     var custom_events_for_textarea = "keyup";
//     if (window.isMobile) {
//         custom_events_for_textarea = "keyup touchend";
//     }

//     $('body').on(custom_events_for_textarea, '#frontText textarea', function(e) {
//         if (e.keyCode === 8) return; // Backspace
//         var new_stuff = $(this).val().replaceAll('\n', '');
//         new_stuff = new_stuff.replace(/[\n\r]+/g, ""); // clean out newlines, so we dont get dups!
//         new_stuff = new_stuff.replace(/(.{16})/g, "$1\n");
//         $(this).val(new_stuff);
//     });

//    $('body').on(custom_events_for_textarea, '.hulkapps_option_779433', function(e) {
  

//     var max = 16;
//     if ($(this).val().length > max) {
//         $(this).val($(this).val().substr(0, max));
//     }
// });



//     $(document).on("click", '[name="hulk_radio_732583"]', function() {
//         if ($(this).attr('data-conditional-value') == 'Front') {
//             $('.hulkapps_option.option_type_id_693544').removeClass('backselected')
//             $('.hulkapps_option.option_type_id_695358').removeClass('backselected')
//             $('.hulkapps_option.option_type_id_693543').addClass('frontselected')
//             $('.hulkapps_option.option_type_id_695357').addClass('frontselected')
//         } else {
//             $('.hulkapps_option.option_type_id_693543').removeClass('frontselected')
//             $('.hulkapps_option.option_type_id_695357').removeClass('frontselected')
//             $('.hulkapps_option.option_type_id_693544').addClass('backselected')
//             $('.hulkapps_option.option_type_id_695358').addClass('backselected')
//         }
//     })

//     $('.etching-button').click(function() {
//         var whichOption = $('input[name="hulk_radio_709835"]:checked').attr('data-conditional-value');
//         var dropdown = $('select.hulkapps_option_child').val();
        
//         if (whichOption == 'Front') {
//             console.log('hello');
//             $('input[name="properties[Text area for bottom etching]"]').val('');
//             $('input[name="properties[Text area for bottom etching]"]').prev().val('');

//             var frontColorValue = $('input[name="hulk_swatch_693543"]:checked').val();
//             var frontTextValue = $('input[name="properties[Text area for side etching]"]').val();
//             var forntcolorselection = false;
//             var frontTextValueselection = false;
//             if (frontColorValue == undefined) {
//                 $('.hulkapps_option.option_type_id_693543').addClass('validation_error')
//             } else {
//                 forntcolorselection = true;
//             }

//             if (frontTextValue.length > 0) {
//                 frontTextValueselection = true;
//             } else {
//                 $('.hulkapps_option.option_type_id_695357').addClass('validation_error')
//             }

//             if (frontTextValue && frontTextValueselection) {
//                 $('.hulkintegration button.add-to-cart.button.button--xl.hulkapps_submit_cart').trigger('click')
//             }
//         } else if(whichOption == 'Bottom') {
          
//             $('input[name="properties[Text area for side etching]"]').val('');
//             $('input[name="properties[Text area for side etching]"]').prev().val('');

//             var backColorValue = $('input[name="hulk_swatch_693544"]:checked').val();
//             var backTextValue = $('input[name="properties[Text area for bottom etching]"]').val();

//             var backcolorselection = false;
//             var backTextValueselection = false;

//             if (backColorValue == undefined) {
//                 $('.hulkapps_option.option_type_id_693544').addClass('validation_error')
//             } else {
//                 backcolorselection = true;
//             }

//             if (backTextValue.length > 0) {
//                 backTextValueselection = true;
//             } else {
//                 $('.hulkapps_option.option_type_id_695358').addClass('validation_error')
//             }

//             if (backcolorselection && backTextValueselection) {
//                 $('.hulkintegration button.add-to-cart.button.button--xl.hulkapps_submit_cart').trigger('click')
//             }

//         }else{
          
//         }

//         console.log(dropdown);
//         if(dropdown == ''){
//           $('.option_type_id_779438').addClass('validation_error')
//         }else{
//           var sideVal = $('.hulkapps_option_779433').val();
//           var bottomVal = $('.hulkapps_option_779434').val();
//           console.log(sideVal)
//           if(sideVal.length > 0 || bottomVal.length > 0){
//             console.log('yes');
//             $('.hulkintegration button.add-to-cart.button.button--xl.hulkapps_submit_cart').trigger('click')
//           }else{
            
//              if(sideVal.length == 0){
//                $('.option_type_id_779434').addClass('validation_error')
//              }
//              if(bottomVal.length == 0){
//                $('.option_type_id_779433').addClass('validation_error')
//              }
//           }
//         }


        
//     })

//     $(document).on('change', 'select.hulkapps_option_child', function() {
//       $('.option_type_id_779434').removeClass('validation_error')
//       $('.option_type_id_779433').removeClass('validation_error')
//     })
  

//     $(document).on('change', 'input[name="hulk_radio_732583"]', function() {
//         var whichOption = $('input[name="hulk_radio_732583"]:checked').attr('data-conditional-value');
//         if (whichOption == 'Front') {
//             $('.hulkapps_option.option_type_id_693544').removeClass('validation_error')
//             $('.hulkapps_option.option_type_id_695358').removeClass('validation_error')
//             $('input[name="properties[Text area for bottom etching]"]').val('');
//             $('input[name="properties[Text area for bottom etching]"]').prev().val('');
//         } else {
//             $('.hulkapps_option.option_type_id_693543').removeClass('validation_error')
//             $('.hulkapps_option.option_type_id_695357').removeClass('validation_error')

//             $('input[name="properties[Text area for side etching]"]').val('');
//             $('input[name="properties[Text area for side etching]"]').prev().val('');
//         }
//     });
// }); 

$(document).ready(function() {
$('.scroll-to-etchting').click(function(){
  $('html, body').animate({
    scrollTop: $(".custom-etching-funct").offset().top - 70
  }, 2000)
})
})
// window.onload = function(){
$(document).ready(function() {  
 var interval = setInterval(function () {
     if (!$("div[id*='hulkapps_custom_options_']").is(':empty')){
        $('.custom-etching-funct').show();
        clearInterval(interval);
     }
if(document.readyState === 'complete') {
  clearInterval(interval);
}
  }, 10);
});
// setTimeout(function(){
//    clearInterval(interval);
// }, 3000);
// }